import { isRuleInsightsRoute } from '@reflex/common/components/rule-insights/ruleInsightsRoute';
import { bootstrap } from '@trident/extension-client';

/**
 * Detects whether this bundle is being loaded as an iframe-hosted single
 * component (Ben Carlson's OneRiver pattern) rather than as the normal Fabric
 * extension. Partner teams (RTH) load our route inside a bare iframe and drive a
 * component (e.g. Rule Insights) over the OneRiver `IframeHost` protocol. In that
 * mode there is no Fabric host to `bootstrap()` against, so we short-circuit and
 * render the component directly.
 *
 * Two recognised signals, both of which only ever occur when we are genuinely
 * framed as a component (so a normal Fabric load is never misclassified):
 *   - `__iframeType=page` — injected by OneRiver's iframe wrapper for the real
 *     partner path (the framework owns this param; it is not our special-case).
 *   - the `#rule-insights` hash route — our own no-query-param mechanism for the
 *     debug harness and lightweight embeds (see `ruleInsightsRoute.ts`).
 */
function isIframeComponent(): boolean {
  if (typeof window === 'undefined' || window.parent === window) {
    return false;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get('__iframeType') === 'page' ||
      isRuleInsightsRoute(window.location.hash)
    );
  } catch {
    return false;
  }
}

const iframeComponent = isIframeComponent();

if (iframeComponent) {
  import(
    /* webpackMode: "lazy" */
    /* webpackChunkName: "extensionIframe" */
    './index.ui.iframe'
  ).then(({ initializeIframeComponent }) => initializeIframeComponent());
} else {
  bootstrap({
    initializeUI: _params =>
      import(
        /* webpackMode: "lazy" */
        /* webpackChunkName: "extensionUi" */
        './index.ui-wrapper'
      ).then(({ initialize }) => initialize(_params)),
    initializeWorker: _params =>
      import(
        /* webpackMode: "lazy" */
        /* webpackChunkName: "extensionWorker" */
        './index.worker'
      ).then(({ initialize }) => initialize(_params)),
  });
}
